import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexFlow: 'column nowrap',
    },
    content: {
      marginTop: theme.spacing(2.5),
      padding: theme.spacing(2.5),
      backgroundColor: COLORS.neutral.silver,
      border: theme.shape.borderPrimaryLight,
      borderRadius: theme.shape.borderRadiusSmall,
    },
    detailsItem: {
      '& + &': {
        marginTop: theme.spacing(2.5),
      },
    },
    footer: {
      display: 'flex',
      flexFlow: 'column',
      alignItems: 'end',
      padding: theme.spacing(2.5, 0, 1.25),
    },
    buttonEdit: {},
  }),
  { name: 'RuleDetails' }
);
